/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap'

import { AppContext } from '../../AppContext'

class InviteUser extends React.Component
{
  emailAddressIsNotUsedBefore = true;
  emailElement = null;

  async checkEmailAddress(emailAddress)
  {
    var bodyData = {};
    bodyData.emailAddress = emailAddress;
    let result = await this.context.dbTwig.callRestAPI('icam', 'validateNewEmailAddress', bodyData);
    switch (result.status)
    {
      case 'success':
        this.setState({emailAddressValid: true}, this.setButtonDisabled);
        break;

      case 'apiError':
        if (this.context.dbTwig.EmailExists === result.errorCode)
        {
          this.setState(
          {
            emailAddressValid: false,
            emailAddressFB: 'This email has already been registered in the system.',
            buttonDisabled: true
          });
          this.emailElement.focus();
          break;
        }

        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new email address.');
        break;

      default:
        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new email address.');
        break;
    }
  }

  componentDidMount()
  {
    if (this.props.tabId === this.props.tabIndex) this.emailElement.focus();
  }
  
  constructor(props)
  {
    super();

    this.state =
    {
      emailAddress: '',
      emailAddressValid: undefined,
      emailAddressFB: null,
      firstName: '',
      firstNameValid: undefined,
      firstNameFB: null,
      lastName: '',
      lastNameValid: undefined,
      lastNameFB: null,
      invitationNote: '',
      buttonDisabled: true
    }

    this.sendInvitation = this.sendInvitation.bind(this);
    this.setEmailAddress = this.setEmailAddress.bind(this);
    this.requiredField = this.requiredField.bind(this);
    this.invitationNoteChanged = this.invitationNoteChanged.bind(this);
  }

  debouncedCheckEmailAddress = window.debounce(this.checkEmailAddress, 500);

  invitationNoteChanged(event)
  {
    this.setState({invitationNote: event.currentTarget.value});
  }

  render()
  {
    if (this.props.tabIndex !== this.props.tabId) return false;

    return(
      <div>
        <Row>
          <Col style={{paddingTop: "10px"}}>
            <h4>Use this form to invite new users to signup for an account.</h4>
          </Col>
        </Row>
        <FormGroup row>
          <Label for="emailAddress" sm="2">Email Address</Label>
          <Col sm={3}>
            <Input type="text" id="emailAddress" placeholder="Enter the person's email address"
              value={this.state.emailAddress} onChange={this.setEmailAddress}
              invalid={(undefined === this.state.emailAddressValid ? undefined : !this.state.emailAddressValid)} 
              valid={(undefined === this.state.emailAddressValid ? undefined : this.state.emailAddressValid)} 
              innerRef={(ref) => this.emailElement = ref}
            />
            <FormFeedback valid={false}>{this.state.emailAddressFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="firstName" sm="2">First Name</Label>
          <Col sm="3">
            <Input type="text" id="firstName" placeholder="First name" value={this.state.firstName} onChange={this.requiredField}
              invalid={(undefined === this.state.firstNameValid ? undefined : !this.state.firstNameValid)} 
              valid={(undefined === this.state.firstNameValid ? undefined : this.state.firstNameValid)} 
            />
            <FormFeedback valid={false}>{this.state.firstNameFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="lastName" sm="2">Last Name</Label>
          <Col sm="3">
            <Input type="text" id="lastName" placeholder="Last name" value={this.state.lastName} onChange={this.requiredField}
              invalid={(undefined === this.state.lastNameValid ? undefined : !this.state.lastNameValid)} 
              valid={(undefined === this.state.lastNameValid ? undefined : this.state.lastNameValid)} 
              />
            <FormFeedback valid={false}>{this.state.lastNameFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="invitationNote" sm="2">Message to send</Label>        
          <Col sm="3">
            <Input type="textarea" id="invitationNote" value={this.state.invitationNote} onChange={this.invitationNoteChanged} 
              placeholder={'Enter a message to include in the invitation here...'} />
          </Col>
        </FormGroup>
        <Row style={{paddingTop: "10px"}}>
          <Col sm={{ size: 2, offset: 2 }}>
            <Button onClick={this.sendInvitation} disabled={this.state.buttonDisabled} color="primary">Invite</Button>
          </Col>
        </Row>
      </div>
    );
  }

  requiredField(event)
  {
    let valid = this.state[event.target.id + 'Valid'];
    let feedback = null;

    if ('' === event.target.value)
    {
      valid = false;
      feedback = 'You must provide a value for this field.';
    }
    else
    {
      valid = true;
    }

    this.setState(
    {
      [event.target.id]: event.target.value, 
      [event.target.id + 'Valid']: valid,
      [event.target.id + 'FB']: feedback
    }, 
    this.setButtonDisabled);
  }
  
  async sendInvitation(event)
  {
    this.setState({buttonDisabled: true});
    event.preventDefault();

    var bodyData = {};
    bodyData.emailAddress = this.state.emailAddress;
    bodyData.firstName = this.state.firstName;
    bodyData.lastName = this.state.lastName;
    bodyData.invitationNote = this.state.invitationNote;

    let result = await this.context.dbTwig.callRestAPI('icam', 'sendInvitation', bodyData);
    if ('success' !== result.status)
    {
      this.setState({buttonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error sending invitation');
    }

    this.context.postNotification('info', 'Invitation sent.');
    this.setState(
    {
      emailAddress: '', 
      emailAddressValid: undefined,
      firstName: '', 
      firstNameValid: undefined,
      lastName: '', 
      lastNameValid: undefined,
      invitationNote: '', 
      buttonDisabled: true
    });
    this.emailElement.focus();
  }

  setButtonDisabled()
  {
    let disabled = (this.state.emailAddressValid && this.state.firstNameValid && this.state.lastNameValid ? false : true);
    this.setState({buttonDisabled: disabled});
  }

  setEmailAddress(event)
  {
    let valid = this.state.emailAddressValid;
    let value = event.target.value.trim();

    let emailAddressFB = null;
    let atSign = value.indexOf('@');
    let dot = value.lastIndexOf('.');
    if ('' === value)
    {
      valid = false;
      emailAddressFB = 'You must provide the email address of the person you want to invite.';
    }

    if ('' !== value && -1 !==  atSign && -1 !== dot && dot > atSign && 
      dot !== (value.length - 1))
    {
      if (!window.emailRegEx.test(value))
      {
        valid = false;
        emailAddressFB = "That does not look like a valid email address";
      }
      else
      {
        this.debouncedCheckEmailAddress(value)
      }
    }      

    this.setState(
    {
      emailAddress: value, 
      emailAddressFB: emailAddressFB, 
      emailAddressValid: valid
    }, 
    this.setButtonDisabled);
  }
}

InviteUser.contextType = AppContext;

export default InviteUser